// Shared category options for tennis competitions
export const CATEGORY_OPTIONS = [
    { value: 'ATP', label: 'ATP' },
    { value: 'Billie Jean King Cup', label: 'Billie Jean King Cup' },
    { value: 'Challenger', label: 'Challenger' },
    { value: 'Davis Cup', label: 'Davis Cup' },
    { value: 'Exhibition', label: 'Exhibition' },
    { value: 'ITF Men', label: 'ITF Men' },
    { value: 'ITF Women', label: 'ITF Women' },
    { value: 'UTR Men', label: 'UTR Men' },
    { value: 'UTR Women', label: 'UTR Women' },
    { value: 'WTA', label: 'WTA' },
    { value: 'WTA 125K', label: 'WTA 125K' },
] as const

export type Category = typeof CATEGORY_OPTIONS[number]['value']

// Gender options for competitions
export const GENDER_OPTIONS = [
    { value: 'men', label: 'Men' },
    { value: 'women', label: 'Women' },
    { value: 'mixed', label: 'Mixed' },
] as const

export type Gender = typeof GENDER_OPTIONS[number]['value']

// Type options for competitions (singles vs doubles)
export const TYPE_OPTIONS = [
    { value: 'singles', label: 'Singles' },
    { value: 'doubles', label: 'Doubles' },
    { value: 'mixed', label: 'Mixed' },
] as const

export type CompetitionType = typeof TYPE_OPTIONS[number]['value']

// Match lifecycle states. Values must match ACE's LifecycleState GraphQL enum
// exactly (apps/ace/internal/service/models.go) — they're sent verbatim as a
// carousel widget filter and compared as-is.
export const LIFECYCLE_OPTIONS = [
    { value: 'LIVE', label: 'Live' },
    { value: 'UPCOMING', label: 'Upcoming' },
    { value: 'ENDED', label: 'Ended' },
] as const

export type LifecycleState = typeof LIFECYCLE_OPTIONS[number]['value']

// Court surfaces. Sportradar-driven vocabulary; no ACE enum backs these.
export const SURFACE_OPTIONS = [
    { value: 'HARD', label: 'Hard' },
    { value: 'CLAY', label: 'Clay' },
    { value: 'GRASS', label: 'Grass' },
    { value: 'CARPET', label: 'Carpet' },
] as const

export type Surface = typeof SURFACE_OPTIONS[number]['value']

// Round labels an editor can set on a match; MatchDetail writes the value into
// tc_round. R1-R5, Q1-Q3, Quarterfinal, Semifinal, Final and Qualifying Final
// are also what a season's tc_round_mapping prints for Sportradar's rounds, so
// these are the labels the match page and match cards show.
export const MATCH_ROUND_OPTIONS = [
    { value: 'R1', label: 'R1' },
    { value: 'R2', label: 'R2' },
    { value: 'R3', label: 'R3' },
    { value: 'R4', label: 'R4' },
    { value: 'R5', label: 'R5' },
    { value: 'Quarterfinal', label: 'Quarterfinal' },
    { value: 'Semifinal', label: 'Semifinal' },
    { value: 'Final', label: 'Final' },
    { value: 'Q1', label: 'Q1' },
    { value: 'Q2', label: 'Q2' },
    { value: 'Q3', label: 'Q3' },
    { value: 'Qualifying Final', label: 'Qualifying Final' },
    { value: 'Round Robin', label: 'Round Robin' },
    { value: 'Day 1', label: 'Day 1' },
    { value: 'Day 2', label: 'Day 2' },
    { value: 'Day 3', label: 'Day 3' },
    { value: 'Exhibition', label: 'Exhibition' },
    { value: 'Gold Medal Match', label: 'Gold Medal Match' },
    { value: 'Bronze Medal Match', label: 'Bronze Medal Match' },
    { value: 'Pro-Am', label: 'Pro-Am' },
    { value: '1st Singles', label: '1st Singles' },
    { value: '2nd Singles', label: '2nd Singles' },
    { value: 'Super Tiebreaker', label: 'Super Tiebreaker' },
] as const
